import { useMediaQuery } from '@vueuse/core';

import type { StateFactory } from '@/injectionKeys';
import { stateFactoryKey } from '@/injectionKeys';

/**
 * パネル開閉 + レスポンシブ制御
 * stateFactory パターンを使用してグローバル状態を管理する
 */
export const useChatPanel = () => {
  const stateFactory = inject(stateFactoryKey) as StateFactory;
  const isOpen = stateFactory.create<boolean>('wabunkaChatPanel', false);
  const isDesktop = useMediaQuery('(min-width: 768px)');
  // サイドパネル（400px）+ メインコンテンツが十分な幅を確保できるブレークポイント
  const isSideLayout = useMediaQuery('(min-width: 1200px)');
  const isSideOpen = computed(() => isSideLayout.value && isOpen.value);

  const open = () => {
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  const toggle = () => {
    isOpen.value = !isOpen.value;
  };

  return {
    isOpen,
    isDesktop,
    isSideLayout,
    isSideOpen,
    open,
    close,
    toggle,
  };
};
